import styled from "@emotion/styled"
import getMediaQuery from "css/breakpoints"
import { wv_willfade } from "./../styles"
import { headline30, body50, bold, visuallyHidden, legend110 } from "css/text"
import { buttonReset } from "css/buttons"

export const Main = styled.div`
  --spacing: 3.125rem;
  display: none;
  flex-direction: column;
  ${wv_willfade}
  &.wv_reveal {
    transition-delay: 300ms;
  }
  position: relative;
  z-index: 1;
  width: 100%;
  --wv-varnav-margin: 15px;

  .wvIncard & {
    display: grid;
    &.wv_reveal {
      transition-delay: 0ms;
    }
//    --spacing: 2rem;
//    display: grid;
  }

  & > p {
    ${body50}
    ${bold}
    padding: 0 var(--outer-margin);
  }

  .wv_reveal & {
    display: grid;
  }

  & > div {
    pointer-events: auto;
    position: relative;
    grid-gap: 0rem;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    scroll-behavior: smooth;
    margin-block-end: 1.25rem;

    --wv-varnav-dot: 0.4375rem;

    .wvIncard & {
      --wv-varnav-margin: min(20px,max(2%, 12px));
      --wv-varnav-dot: 0.35rem;
      margin-block-end: .5rem;
      mask-image: linear-gradient(90deg, rgb(0 0 0 / 0.2), rgb(0 0 0 / 1) 20%, rgb(0 0 0 / 1) 80%, rgb(0 0 0 / 0.2) 100%);

      &.prevonly.nextonly {
        mask-image: unset;
      }
      &.prevonly {
        mask-image: linear-gradient(90deg, rgb(0 0 0 / 0.2), rgb(0 0 0 / 1) 20%, rgb(0 0 0 / 1) 100%);
        [dir="rtl"] & {
          mask-image: linear-gradient(90deg, rgb(0 0 0 / 1), rgb(0 0 0 / 1) 80%, rgb(0 0 0 / 0.2) 100%);
        }
      }
      &.nextonly {
        mask-image: linear-gradient(90deg, rgb(0 0 0 / 1), rgb(0 0 0 / 1) 80%, rgb(0 0 0 / 0.2) 100%);
        [dir="rtl"] & {
          mask-image: linear-gradient(90deg, rgb(0 0 0 / 0.2), rgb(0 0 0 / 1) 20%, rgb(0 0 0 / 1) 100%);
        }
      }
    }

    &::before {
      content: "";
      flex: 0 0 calc(var(--outer-margin) - var(--wv-varnav-margin));

      .wvIncard & {
        flex: 0 0 calc(var(--gv-padding-inline) - var(--wv-varnav-margin));
      }
    }
    &::after {
      content: "";
      flex: 0 0 var(--outer-margin);

      .wvIncard & {
        flex: 0 0 var(--gv-padding-inline);
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }

    justify-items: center;

    & > div {
      pointer-events: none;
      position: relative;
      display: block;

      ${buttonReset}
      ${headline30}

      .wvIncard & {
        ${legend110}
      }
      white-space: nowrap;
      transition: color 0.3s;

      > span {
        display: block;
        padding-inline: var(--wv-varnav-margin);
        margin-block: 2px;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          margin-block-start: -2px;
          margin-inline-start: 5px;
          width: var(--wv-varnav-dot);
          height: var(--wv-varnav-dot);
          border-radius: var(--wv-varnav-dot);
          background: rgb(var(--green));
          opacity: 0;
          transition: opacity 0.3s;
        }
      }

      > input {
        border-radius: 0;
        appearance: none;
        pointer-events: auto;
        position: absolute;
        z-index: 1;
        outline: 0;
//        background: rgba(255,0,0,1);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        &:disabled + span {
          color: rgb(var(--grey));
        }

        &:checked + span {
          color: rgb(var(--green));
          &::after {
            opacity: 1;
          }
        }
        
        @media (hover: hover) {
          &:not(:disabled) {
            cursor: pointer;
            &:hover + span {
              color: rgb(var(--green));
            }
          }
        }

        &.focus-visible + span {
          outline: 2px solid rgb(var(--focus, 0 255 255) / 1);
          outline-offset: 0px !important;
        }
      }
    }
  }
`
